/* Daza Organic · «Por qué funciona», comportamiento pedido por el cliente:
   en escritorio las 3 tarjetas caben siempre en una fila (flex-grow, no %),
   una es la «activa» —más ancha— por autoplay cada 5s o por hover, y en
   mobile es un carrusel de scroll real con flechas. Sin librerías: un
   custom element vanilla. Si el JS no carga, el CSS solo (ver
   daza-ficha.css) ya deja las 3 en fila sin efecto de ancho, así que la
   marca no depende de esto para verse bien. */
(function () {
  'use strict';

  function definir() {
    if (customElements.get('daza-porque-carrusel')) return;

    customElements.define('daza-porque-carrusel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.listo) return;
        this.dataset.listo = '1';

        var track = this.querySelector(':scope > ul.s-ficha__porque');
        var items = track ? [].slice.call(track.children) : [];
        var prevBtn = this.querySelector('.s-ficha__porque-flecha--prev');
        var nextBtn = this.querySelector('.s-ficha__porque-flecha--next');
        if (!track || items.length < 2) return;

        var mqDesktop = window.matchMedia('(min-width:750px)');
        var reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
        var activo = 0;
        var timer = null;

        function marcar(i) {
          activo = i;
          items.forEach(function (li, idx) {
            li.classList.toggle('is-activa', idx === activo);
          });
        }

        function iniciarAuto() {
          if (timer || !mqDesktop.matches || reduce.matches) return;
          timer = setInterval(function () {
            marcar((activo + 1) % items.length);
          }, 5000);
        }
        function detenerAuto() {
          clearTimeout(timer);
          clearInterval(timer);
          timer = null;
        }

        marcar(0);
        iniciarAuto();

        // Hover (y foco de teclado, mismo criterio) activa esa tarjeta y
        // pausa el autoplay mientras el cursor siga encima.
        items.forEach(function (li, idx) {
          li.addEventListener('mouseenter', function () {
            if (!mqDesktop.matches) return;
            detenerAuto();
            marcar(idx);
          });
          li.addEventListener('mouseleave', function () {
            if (mqDesktop.matches) iniciarAuto();
          });
          li.addEventListener('focusin', function () {
            if (!mqDesktop.matches) return;
            detenerAuto();
            marcar(idx);
          });
          li.addEventListener('focusout', function () {
            if (mqDesktop.matches) iniciarAuto();
          });
        });

        mqDesktop.addEventListener('change', function (e) {
          if (e.matches) iniciarAuto();
          else detenerAuto();
        });
        reduce.addEventListener('change', function (e) {
          if (e.matches) detenerAuto();
          else iniciarAuto();
        });

        // Mobile: flechas que desplazan el track una tarjeta exacta —nunca
        // scrollIntoView, que puede alinear a una tarjeta a medias si el
        // gap no calza con el viewport.
        function anchoPaso() {
          var li = items[0];
          var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
          return li.getBoundingClientRect().width + gap;
        }
        function indiceActual() {
          var paso = anchoPaso();
          return paso > 0 ? Math.round(track.scrollLeft / paso) : 0;
        }
        function irA(i) {
          i = Math.max(0, Math.min(items.length - 1, i));
          track.scrollTo({ left: i * anchoPaso(), behavior: reduce.matches ? 'auto' : 'smooth' });
        }
        function actualizarFlechas() {
          var i = indiceActual();
          if (prevBtn) prevBtn.disabled = i <= 0;
          if (nextBtn) nextBtn.disabled = i >= items.length - 1;
        }

        if (prevBtn) prevBtn.addEventListener('click', function () { irA(indiceActual() - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { irA(indiceActual() + 1); });

        var scrollTimer;
        track.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(actualizarFlechas, 100);
        }, { passive: true });
        actualizarFlechas();
      }
    });
  }

  definir();
  document.addEventListener('shopify:section:load', definir);
})();
